/* eslint-disable react-hooks/exhaustive-deps */
import { getMinMaxPriceHotel, getRating } from "helpers/hotelHelper";
import { useHotelContext } from "hooks/hotel/useHotelContext";
import Nouislider from "nouislider-react";
import { useEffect, useState } from "react";
import {
    Offcanvas,
    OffcanvasHeader,
    OffcanvasBody,
    Card,
    Col,
} from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { BsStarFill } from "react-icons/bs";
import { IoClose } from "react-icons/io5";

const initFilteredByList = {
    price: false,
    Stars: {
        one: false,
        two: false,
        three: false,
        four: false,
        five: false,
    },
    hotelName: "",
};

const starsObj = [
    {value : 1, label : "one"},
    {value : 2, label : "two"},
    {value : 3, label : "three"},
    {value : 4, label : "four"},
    {value : 5, label : "five"},
]

const MobileFilters = ({ isOpen, toggle, setFilteredHotels }) => {
    const { t } = useTranslation();
    const [priceRange, setPriceRange] = useState([`0`, "1"]);
    const { availabilityResults } = useHotelContext();
    let [minPrice, maxPrice] = getMinMaxPriceHotel(availabilityResults?.hotels);
    const [filteredByList, setFilteredByList] = useState(initFilteredByList);
    useEffect(() => {
        setPriceRange([minPrice.toString(), maxPrice.toString()]);
    }, [availabilityResults, minPrice, maxPrice]);

    useEffect(() => {
        applyFilter();
    }, [filteredByList]);

    const applyFilter = () => {
        let filteredHotels = availabilityResults?.hotels.filter((hotel) => {
            return Object.keys(filteredByList).every((key) => {
                if (key === "price") {
                    if (filteredByList.price) {
                        return (
                            Math.ceil(+hotel?.minRate?.total) >=
                                Math.floor(parseInt(priceRange[0])) &&
                            Math.floor(+hotel?.minRate?.total) <=
                                Math.ceil(parseInt(priceRange[1]))
                        );
                    }
                }
                if (key === "Stars") {
                    if (
                        filteredByList.Stars.one ||
                        filteredByList.Stars.two ||
                        filteredByList.Stars.three ||
                        filteredByList.Stars.four ||
                        filteredByList.Stars.five
                    ) {
                        const rating = getRating(hotel?.stars);
                        if (
                            (filteredByList.Stars.one && rating === 1) ||
                            (filteredByList.Stars.two && rating === 2) ||
                            (filteredByList.Stars.three && rating === 3) ||
                            (filteredByList.Stars.four && rating === 4) ||
                            (filteredByList.Stars.five && rating === 5)
                        ) {
                            return true;
                        } else {
                            return false;
                        }
                    }
                }
                if (key === "hotelName") {
                    if (filteredByList.hotelName !== "") {
                        return hotel?.name
                            ?.toLowerCase()
                            .includes(filteredByList.hotelName.toLowerCase());
                    }
                }
                return true;
            });
        });
        setFilteredHotels(filteredHotels);
    };

    const clearFilters = () => {
        setPriceRange([minPrice.toString(), maxPrice.toString()]);
        setFilteredByList({
            ...initFilteredByList,
        });
    };

    return (
        <Offcanvas
            data-bs-scroll="true"
            data-bs-backdrop="static"
            placement="end"
            show={isOpen}
            onHide={toggle}
            className="h-screen w-[90%] md:w-[60%] lg:w-[40%] "
            tabIndex={-1}
            id="offcanvasSiddebar"
            aria-labelledby={`filters`}
        >
            <OffcanvasHeader className="offcanvas-header py-2 px-3  w-full flex justify-between items-center">
                <h5 className="font-semibold">Filters</h5>
                <div className="cursor-pointer " onClick={toggle} >
                    <IoClose cursor={"pointer"} size={22} />
                </div>
            </OffcanvasHeader>
            <OffcanvasBody className="offcanvas-body flex-column p-2 ">
                <div className="w-full rounded-xl p-2 flex flex-col gap-2 border border-border-color">
                    <Card className="card-body rounded-md p-4">
                        <div className="mb-2 text-default fw-bold text-md">
                            {t("hotelName")}
                        </div>
                        <Col>
                            <input
                                className="form-control bg_input"
                                type="text"
                                placeholder={t("hotelName") + "..."}
                                value={filteredByList.hotelName}
                                onChange={(e) => {
                                    setFilteredByList((prev) => ({
                                        ...prev,
                                        hotelName: e.target.value,
                                    }));
                                }}
                            />
                        </Col>
                    </Card>
                    <Card className="card-body rounded-md p-4">
                        <div className="mb-2 text-default fw-bold text-md">
                            {t("price")}
                        </div>
                        <div className="position-relative">
                            <div className="noui-wrapper">
                                <div className="d-flex justify-content-between">
                                    <input
                                        type="text"
                                        className="text-body input-with-range-min"
                                        value={priceRange[0].split(".")[0]}
                                        readOnly
                                    />
                                    <input
                                        type="text"
                                        className="text-body input-with-range-max"
                                        value={priceRange[1].split(".")[0]}
                                        readOnly
                                    />
                                </div>
                                <Nouislider
                                    start={priceRange}
                                    range={{ min: minPrice, max: maxPrice }}
                                    step={1}
                                    onChange={(values) => {
                                        setPriceRange(values);
                                        setFilteredByList({
                                            ...filteredByList,
                                            price: true,
                                        });
                                    }}
                                    className="noui-slider-range mt-2 b-none"
                                    connect
                                />
                            </div>
                        </div>
                    </Card>
                    <Card className="card-body rounded-md p-4">
                        {/* <div className="left_side_search_heading">
                            <div className="text-md text-default fw-bold">
                                {t("starts")}
                            </div>
                        </div>
                        <div className="tour_search_type">
                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="onwardDirect"
                                    // checked={filteredByList.Onward.direct}
                                    // onChange={(e) =>
                                    //     handleOnwardStop(
                                    //         "direct",
                                    //         e.target.checked
                                    //     )
                                    // }
                                />
                                <label
                                    className="form-check-label"
                                    htmlFor="onwardDirect"
                                >
                                    <span className="area_flex_one">
                                        {t("direct")}
                                    </span>
                                </label>
                            </div>
                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="onwardOneStop"
                                    // checked={filteredByList.Onward.oneStop}
                                    // onChange={(e) =>
                                    //     handleOnwardStop(
                                    //         "oneStop",
                                    //         e.target.checked
                                    //     )
                                    // }
                                />
                                <label
                                    className="form-check-label"
                                    htmlFor="onwardOneStop"
                                >
                                    <span className="area_flex_one">
                                        {t("stop1")}
                                    </span>
                                </label>
                            </div>
                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="onwardTwoStop"
                                    // checked={filteredByList.Onward.twoStop}
                                    // onChange={(e) =>
                                    //     handleOnwardStop(
                                    //         "twoStop",
                                    //         e.target.checked
                                    //     )
                                    // }
                                />
                                <label
                                    className="form-check-label"
                                    htmlFor="onwardTwoStop"
                                >
                                    <span className="area_flex_one">
                                        {t("stop+2")}
                                    </span>
                                </label>
                            </div>
                        </div> */}
                        <div className="mb-2 text-default fw-bold fs-5">
                            {t("ratingStar")}
                        </div>
                        <div className="d-flex flex-wrap mb-0 gap-2 ">
                            {
                                starsObj.map((star) => (
                                    <div className="  mb-0" key={star.value}>
                                        <input
                                            type="checkbox"
                                            className="btn-check"
                                            id={`btn-check-${star.value}`}
                                            onChange={() =>
                                                setFilteredByList({
                                                    ...filteredByList,
                                                    Stars: {
                                                        ...filteredByList.Stars,
                                                        [star.label]: !filteredByList.Stars[star.label],
                                                    },
                                                })
                                            }
                                            checked={filteredByList.Stars[star.label]}
                                        />
                                        <label
                                            className={`flex gap-1 items-center w-full p-2 rounded-md bg-hover-color cursor-pointer duration-200 ${filteredByList.Stars[star.label] ? "bg-main-color text-white" : ""}`}
                                            htmlFor={`btn-check-${star.value}`}
                                        >
                                            {star.value}<BsStarFill />
                                        </label>
                                    </div>
                                ))
                            }
                            {/* <div className="  mb-0">
                                <input
                                    type="checkbox"
                                    className="btn-check"
                                    id="btn-check-6"
                                    onChange={() =>
                                        setFilteredByList({
                                            ...filteredByList,
                                            Stars: {
                                                ...filteredByList.Stars,
                                                one: !filteredByList.Stars.one,
                                            },
                                        })
                                    }
                                    checked={filteredByList.Stars.one}
                                />
                                <label
                                    className={`flex gap-1 items-center w-full p-2 rounded-md bg-hover-color`}
                                    htmlFor="btn-check-6"
                                >
                                    1<BsStarFill />
                                </label>
                            </div> */}

                        </div>
                    </Card>
                    <button
                        onClick={clearFilters}
                        className="btn btn-primary bg-main-color mt-2"
                    >
                        {t("clearFilters")}
                    </button>
                </div>
            </OffcanvasBody>
        </Offcanvas>
    );
};

export default MobileFilters;
